module.exports = __webpack_public_path__ + "static/media/curve-dark.ebd8aa5e.svg";